// @flow

import * as React from 'react';
import useSheet from 'app/jss';

type Props = {
  classes: Object,
  style: Object,
  width: number,
  height: number,
  ratio: { h: number, w: number },
  gutterStyle: Object,
  children: any,
  animationDelay?: number
};

const defaultProps = {
  animationDelay: 0
};

function GridLayoutItem(props: Props) {
  const { classes, children, style, gutterStyle, height, width, ratio, animationDelay } = props;

  // paddingBottom percent bases itself off the current width would you believe
  // so we're using this to maintain the aspect ratio
  const wrapperStyle = {
    paddingBottom: `${((ratio.h * height) / (ratio.w * width)) * 100}%`,
    transitionDelay: `${animationDelay}s`
  };

  const gridItemStyle = {
    ...style,
    transitionDelay: `${animationDelay}s`
  };

  return (
    <div style={gridItemStyle} className={classes.gridItem}>
      <div style={wrapperStyle} className={classes.wrapper}>
        <div className={classes.inner} style={gutterStyle}>
          {children}
        </div>
      </div>
    </div>
  );
}

GridLayoutItem.defaultProps = defaultProps;

function applyStyles() {
  return {
    gridItem: {
      position: 'absolute',
      transition: ['width 0.3s ease-in-out', 'transform 0.3s ease-in-out'].join(', ')
    },
    wrapper: {
      transition: 'padding-bottom 0.3s ease-in-out'
    },
    inner: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  };
}

export default useSheet(applyStyles)(GridLayoutItem);
